import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EvaDropdownComponent } from './eva-dropdown.component';
import { EvaDropdownItemComponent } from './eva-dropdown-item.component';

@NgModule({
    declarations: [
        EvaDropdownComponent,
        EvaDropdownItemComponent
    ],
    imports: [ 
        CommonModule
    ],
    exports: [
        EvaDropdownComponent,
        EvaDropdownItemComponent
    ],
    providers: [],
})
export class EvaDropdownModule {}